import React from "react";

const SparklesStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 2.75C13 5.51142 11.5114 8 8.75 8C11.5114 8 13 10.4886 13 13.25C13 10.4886 14.4886 8 17.25 8C14.4886 8 13 5.51142 13 2.75Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 10.75C6 12.4069 4.40685 14 2.75 14C4.40685 14 6 15.5931 6 17.25C6 15.5931 7.59315 14 9.25 14C7.59315 14 6 12.4069 6 10.75Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SparklesStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;